var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"InputSearch"},[_vm._m(0),_c('input',_vm._g(_vm._b({staticClass:"InputSearch-Input"},'input',_vm.$attrs,false),_vm.$listeners))])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"InputSearch-Icon"},[_c('i',{staticClass:"fas fa-search"})])
}]

export { render, staticRenderFns }